package ui.component.external

import emotion.react.css
import helpers.isPhone
import js.lazy.Lazy
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.useNavigate
import react.useContext
import ru.malygin.myConst.jsMainDebugUnit
import ui.component.buttons.miniIconButton
import ui.router.RouterRoute
import ui.styles.DrawerStyle
import ui.styles.icons.AppLOGOIconSVG
import ui.styles.icons.BlurOnRoundedIconSVG
import ui.styles.icons.CloseRoundedIconSVG
import ui.styles.icons.IconsSVG
import ui.themePlusContext.*
import utils.logger.log
import web.cssom.*
import web.dom.document

//drawer // side navigation

enum class DrawerParams(
    val value: Any
){
    ID("drawer_id_key"),
    ID_HIDE("drawer_id_hide_key"),
    TIMEOUT(3000)
}

enum class DialogRefTop(
    val text: String,
    val navigateTo: String?,
    val iconsSVG: IconsSVG?,
    val customFC: FC<*> = FC{}
){
    THEME_SWITCH(
        text = "Сменить тему",
        navigateTo = null,
        iconsSVG = null,
        customFC = themeSwitch
    ),
    FIND_TEACHER(
        text = "Найти преподавателя",
        navigateTo = RouterRoute.FIND_TEACHER_PAGE.route,
        iconsSVG = null,//todo
    ),
}
enum class DialogRefBottom(
    val text: String,
    val navigateTo: String?,
    val iconsSVG: IconsSVG?
){
    MORE(
        text = "Ещё",
        navigateTo = RouterRoute.MORE_PAGE.route,
        iconsSVG = BlurOnRoundedIconSVG,
    ),
}

@Lazy
val DrawerUnit = FC{

    ReactHTML.div{
        id = DrawerParams.ID_HIDE.value.toString()
        className = ClassName(DialogParams.ID_DIALOG.className.toString())

        onClick = {event ->
            val doU = event.target == document.getElementById(DrawerParams.ID_HIDE.value.toString())
            log.i("event.target == document.getElementById(DrawerParams.ID_HIDE.value) is $doU")
            if (doU){
                drawerOpenClose()
            }
        }

    }
    ReactHTML.div{
        id = DrawerParams.ID.value.toString()
        className = DrawerStyle.drawerHandler

        drawerList()
    }
}

private val drawerList = FC {

    ReactHTML.div{
        ReactHTML.div{
            className = DrawerStyle.drawerTitleBox

            css(this.className) {
                gap = 10.px
                display = Display.flex
                justifyContent = JustifyContent.center
                marginBottom = 10.px
                marginInline = 10.px
            }

            AppLOGOIconSVG.iconSVG()

        }
        ReactHTML.div{
            css {
                position = Position.absolute
                top = 10.px
                right = 10.px
            }

            miniIconButton{
                this.onClick = {
                    drawerOpenClose()
                }
                this.realIconSVG = CloseRoundedIconSVG
            }
        }

        ReactHTML.hr{
            css {
                marginBottom = 10.px
            }
        }

        ReactHTML.div{
            className = DrawerStyle.drawerTopBox

            DialogRefTop.entries.forEach { dialogRef->
                when(dialogRef){
                    DialogRefTop.THEME_SWITCH -> dialogRef.customFC()
                    else -> {
                        DrawerItem{
                            text = dialogRef.text
                            navigateTo = dialogRef.navigateTo
                            iconsSVG = dialogRef.iconsSVG
                        }
                    }
                }
            }
        }
    }


    ReactHTML.div{
        className = DrawerStyle.drawerBottomBox

        DialogRefBottom.entries.forEach { dialogRef->
            when{
                dialogRef == DialogRefBottom.MORE -> {
                    DrawerItem{
                        text = dialogRef.text
                        navigateTo = dialogRef.navigateTo
                        iconsSVG = dialogRef.iconsSVG
                    }
                }
                else -> {
                    jsMainDebugUnit {
                        DrawerItem{
                            text = dialogRef.text
                            navigateTo = dialogRef.navigateTo
                            iconsSVG = dialogRef.iconsSVG
                        }
                    }
                }
            }
        }

    }
}

fun drawerOpenClose(
    open: Boolean = false,
){
    val x = document.getElementById(DrawerParams.ID.value.toString())
    val x2 = document.getElementById(DrawerParams.ID_HIDE.value.toString())

    if (open){
        x2?.style?.display = "block"
        x?.classList?.add(DrawerStyle.drawerOpenToken)
    }else{
        x?.classList?.remove(DrawerStyle.drawerOpenToken)
        x2?.style?.display = "none"
    }
}

external interface DrawerItemProps : Props {
    var text: String
    var navigateTo: String?
    var iconsSVG: IconsSVG?
}

private val DrawerItem = FC<DrawerItemProps> { props ->
    val isPhone = isPhone()
    val navigator = useNavigate()

    val text1 = props.text.takeIf { it != undefined } ?: "ошибка"
    val navigateTo1 = props.navigateTo?.takeIf { it != undefined }
    val iconsSVG1 = props.iconsSVG?.takeIf { it != undefined }

    ReactHTML.a{

        onClick = {_->
            drawerOpenClose()
            navigateTo1?.let { navigator(to = it) }
        }

        if (!isPhone){
            iconsSVG1?.iconSVG()
        }

        +text1
    }
}